import { Perishable } from 'app/design/icons/perishable';
import { Row, Text, useTheme } from 'app/shopify';
import { useTranslation } from 'react-i18next';

interface StatusPerishableProps {
  compact?: boolean;
  withText?: boolean;
}

export function StatusPerishable({ compact = false, withText = true }: StatusPerishableProps) {
  const theme = useTheme();
  const { t } = useTranslation('common');

  if (compact) {
    return (
      <Row
        alignItems="center"
        alignSelf="flex-start"
        backgroundColor="surface.tertiary-neutral"
        borderRadius="radius.xl"
        gap="spacing.general.x1"
        maxWidth="100%"
        paddingHorizontal="spacing.general.x2"
        paddingVertical="spacing.general.x1"
      >
        <Perishable color={theme.colors['icon.secondary']} height={16} width={16} />
        <Text color="text.secondary" fontWeight="500" numberOfLines={1} variant="bodySmall">
          {t('perishable')}
        </Text>
      </Row>
    );
  }

  return (
    <Row
      alignSelf="flex-start"
      backgroundColor="surface.tertiary-neutral"
      height={withText ? undefined : 24}
      paddingHorizontal={withText ? 'spacing.general.x1' : undefined}
      paddingVertical={withText ? 'spacing.general.x1' : undefined}
      width={withText ? undefined : 24}
      justifyContent="center"
      alignItems="center"
      borderRadius="radius.xl"
    >
      <Perishable color={theme.colors.black} />
      {withText ? <Text>{t('perishable')}</Text> : null}
    </Row>
  );
}

export default StatusPerishable;
